import { render, staticRenderFns } from "./NotaExplicativaBP.vue?vue&type=template&id=76c1d579"
import script from "./NotaExplicativaBP.vue?vue&type=script&lang=js"
export * from "./NotaExplicativaBP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports